<ng-template #skeleton>
  <div class="skeleton" animate.leave="fade-out">
    <div class="line">
      <ngx-skeleton-loader [appearance]="'line'" [theme]="channel" />
      <ngx-skeleton-loader [theme]="text(4)" />
      <ngx-skeleton-loader [theme]="channel" class="icon" />
    </div>
    <div class="level">
      <div class="line">
        <ngx-skeleton-loader [theme]="channel" />
        <ngx-skeleton-loader [theme]="text(6)" />
        <ngx-skeleton-loader [theme]="channel" class="icon" />
      </div>
      <div class="line">
        <ngx-skeleton-loader [theme]="channel" />
        <ngx-skeleton-loader [theme]="text(7)" />
      </div>
      <div class="level">
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(6)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(4)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(4)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(4)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(4)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(5)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(3)" />
        </div>
      </div>
      <div class="line">
        <ngx-skeleton-loader [theme]="channel" />
        <ngx-skeleton-loader [theme]="text(8)" />
      </div>
      <div class="level">
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(6)" />
        </div>
        <div class="level">
          <div class="line">
            <ngx-skeleton-loader [theme]="user" />
            <ngx-skeleton-loader [theme]="text(7)" />
            <ngx-skeleton-loader [theme]="channel" class="icon" />
            <ngx-skeleton-loader [theme]="channel" class="icon" />
            <ngx-skeleton-loader [theme]="channel" class="icon" />
          </div>
          <div class="line">
            <ngx-skeleton-loader [theme]="user" />
            <ngx-skeleton-loader [theme]="text(4)" />
            <ngx-skeleton-loader [theme]="channel" class="icon" />
            <ngx-skeleton-loader [theme]="channel" class="icon" />
          </div>
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(6)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(5)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(7)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(8)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(7)" />
        </div>
        <div class="line">
          <ngx-skeleton-loader [theme]="channel" />
          <ngx-skeleton-loader [theme]="text(4)" />
        </div>
      </div>
      <div class="line">
        <ngx-skeleton-loader [theme]="channel" />
        <ngx-skeleton-loader [theme]="text(4)" />
        <ngx-skeleton-loader [theme]="channel" class="icon" />
      </div>
    </div>
  </div>
</ng-template>

<app-card-shell title="TeamSpeak 3" [online]="dataAvailable()">
  <picture card-image>
    <source type="image/avif" [srcset]="avifSrcset" [sizes]="cardTopImageSizes" />
    <img
      class="card-img-top"
      priority
      fill
      draggable="false"
      ngSrc="/assets/img/games/teamspeak.webp"
      [sizes]="cardTopImageSizes"
      alt="Background image of the teamspeak card." />
  </picture>
  <div class="tree">
    <div class="holder row position-relative">
      @let result = this.state();
      @switch (result.status) {
        @case ('error') {
          @let error = result.error;
          @if (error !== null && isHttpStatus(error, 503)) {
            <span>Currently unavailable</span>
          } @else {
            <span>There has been a problem loading the data.{{ error.message }}</span>
          }
        }
        @case ('loaded') {
          @let server = this.state().data!;
          <div animate.enter="fade-in" animate.leave="fade-out">
            <ul
              class="list-unstyled mb-0"
              style="
                font-family: Arial, sans-serif;
                font-size: 14px;
                line-height: 16px;
                image-rendering: pixelated !important;
              ">
              <li>
                <div class="d-flex justify-content-between" style="height: 16px">
                  <div class="align-self-start">
                    <picture>
                      <source type="image/avif" srcset="/assets/img/ts/server.avif" />
                      <img
                        class="align-self-start"
                        style="vertical-align: top"
                        ngSrc="/assets/img/ts/server.webp"
                        alt="Client"
                        width="16"
                        height="16"
                        disableOptimizedSrcset />
                    </picture>
                    <span class="ms-1">{{ server.name }}</span>
                  </div>
                  <div class="align-self-end d-flex justify-content-start align-items-center" style="gap: 0.125rem">
                    @if (server.iconId) {
                      <picture>
                        @if (this.getIconAvifUrl(server.iconId!); as avifUrl) {
                          <source type="image/avif" srcset="{{ avifUrl }}" />
                        }
                        <img
                          ngSrc="{{ this.getIconUrl(server.iconId!) }}"
                          alt="Server Icon"
                          width="16"
                          height="16"
                          disableOptimizedSrcset />
                      </picture>
                    }
                  </div>
                </div>
                <ul class="list-unstyled ms-3">
                  @for (channel of server.channels; track trackChannel($index, channel)) {
                    <li style="margin-top: 1px">
                      <ng-container *ngTemplateOutlet="channelTemplate; context: { channel: channel }" />
                    </li>
                  }
                </ul>

                <ng-template #clientTemplate let-clientAny="client">
                  @if (asClient(clientAny); as client) {
                    <div class="d-flex justify-content-between" style="height: 16px">
                      <div class="align-self-start">
                        <picture>
                          <source type="image/avif" srcset="assets/img/ts/{{ this.clientIconAvif(client) }}" />
                          <img
                            class="align-self-start"
                            ngSrc="assets/img/ts/{{ this.clientIcon(client) }}"
                            alt="Client"
                            width="16"
                            height="16"
                            disableOptimizedSrcset />
                        </picture>
                        <span class="ms-1">{{ client.name }}</span>
                      </div>
                      <div class="align-self-end d-flex justify-content-start align-items-center" style="gap: 0.125rem">
                        @if (client.channelGroup && client.channelGroup.iconId) {
                          <picture>
                            @if (this.getIconAvifUrl(client.channelGroup.iconId); as avifUrl) {
                              <source type="image/avif" srcset="{{ avifUrl }}" />
                            }
                            <img
                              alt="Icon for the channel group {{ client.channelGroup.name }}"
                              title="{{ client.channelGroup.name }}"
                              ngSrc="{{ this.getIconUrl(client.channelGroup.iconId) }}"
                              width="16"
                              height="16"
                              disableOptimizedSrcset />
                          </picture>
                        }
                        @for (sg of client.serverGroups; track trackGroup($index, sg)) {
                          @if (sg?.iconId) {
                            <picture>
                              @if (this.getIconAvifUrl(sg!.iconId!); as avifUrl) {
                                <source type="image/avif" srcset="{{ avifUrl }}" />
                              }
                              <img
                                alt="Icon for the server group {{ sg!.name }}"
                                title="{{ sg!.name }}"
                                ngSrc="{{ this.getIconUrl(sg!.iconId!) }}"
                                width="16"
                                height="16"
                                disableOptimizedSrcset />
                            </picture>
                          }
                        }
                        @if (client.clientIcon) {
                          <picture>
                            @if (this.getIconAvifUrl(client.clientIcon); as avifUrl) {
                              <source type="image/avif" srcset="{{ avifUrl }}" />
                            }
                            <img
                              alt="Client Icon"
                              title="Client Icon"
                              ngSrc="{{ this.getIconUrl(client.clientIcon) }}"
                              width="16"
                              height="16"
                              disableOptimizedSrcset />
                          </picture>
                        }
                        @if (client.country || 'UNKNOWN'; as country) {
                          <picture>
                            <source type="image/avif" srcset="{{ this.getFlagIconAvifUrl(country) }}" />
                            <img
                              alt="Flag of {{ country }}"
                              title="{{ country }}"
                              ngSrc="{{ this.getFlagIconUrl(country) }}"
                              width="16"
                              height="11"
                              disableOptimizedSrcset />
                          </picture>
                        }
                      </div>
                    </div>
                  }
                </ng-template>
                <ng-template #channelTemplate let-channelAny="channel">
                  @if (asChannel(channelAny); as channel) {
                    <div class="d-flex justify-content-between" style="height: 16px">
                      @if (channel.spacer) {
                        @switch (channel.spacer.type) {
                          @case ('left') {
                            <span>{{ channel.spacer.text }}</span>
                          }
                          @case ('center') {
                            <span class="w-100 text-center">{{ channel.spacer.text }}</span>
                          }
                          @case ('right') {
                            <span class="w-100 text-end">{{ channel.spacer.text }}</span>
                          }
                          @case ('repeat') {
                            <span class="overflow-hidden">
                              @if (channel.spacer.text) {
                                @for (_ of [].constructor(100 / (channel.spacer.text.length || 100)); track _) {
                                  {{ channel.spacer.text }}
                                }
                              }
                            </span>
                          }
                        }
                      } @else {
                        <div class="align-self-start">
                          <picture>
                            <source type="image/avif" srcset="assets/img/ts/{{ this.channelIconAvif(channel) }}" />
                            <img
                              class="align-self-start"
                              style="vertical-align: top"
                              ngSrc="assets/img/ts/{{ this.channelIcon(channel) }}"
                              alt="Channel {{ channel.isPasswordProtected ? ' (password protected)' : '' }}"
                              title="Channel {{ channel.isPasswordProtected ? ' (password protected)' : '' }}"
                              height="16"
                              width="16"
                              disableOptimizedSrcset />
                          </picture>
                          <span class="ms-1">{{ channel.name }}</span>
                        </div>
                        <div
                          class="align-self-end d-flex justify-content-start align-items-center"
                          style="gap: 0.125rem">
                          @if (channel.isDefault) {
                            <picture>
                              <source type="image/avif" srcset="../../../../assets/img/ts/channel-home.avif" />
                              <img
                                title="Default channel"
                                ngSrc="../../../../assets/img/ts/channel-home.webp"
                                width="16"
                                height="16"
                                disableOptimizedSrcset
                                alt="Default channel" />
                            </picture>
                          }
                          @if (channel.isPasswordProtected) {
                            <picture>
                              <source
                                type="image/avif"
                                srcset="../../../../assets/img/ts/channel-password-right.avif" />
                              <img
                                ngSrc="../../../../assets/img/ts/channel-password-right.webp"
                                width="16"
                                height="16"
                                disableOptimizedSrcset
                                alt="Password protected"
                                title="This channel is password protected." />
                            </picture>
                          }
                          @if (channel.iconId) {
                            <picture>
                              @if (this.getIconAvifUrl(channel.iconId); as avifUrl) {
                                <source type="image/avif" srcset="{{ avifUrl }}" />
                              }
                              <img
                                ngSrc="{{ this.getIconUrl(channel.iconId) }}"
                                width="16"
                                height="16"
                                disableOptimizedSrcset
                                alt="Channel Icon" />
                            </picture>
                          }
                        </div>
                      }
                    </div>
                    <ul class="list-unstyled ms-3">
                      @for (client of channel?.clients; track [client.id, client.name]) {
                        <li style="margin-top: 1px">
                          <ng-container *ngTemplateOutlet="clientTemplate; context: { client: client }" />
                        </li>
                      }
                      @for (channel of channel?.channels; track channel.id) {
                        <li style="margin-top: 1px">
                          <ng-container *ngTemplateOutlet="channelTemplate; context: { channel: channel }" />
                        </li>
                      }
                    </ul>
                  }
                </ng-template>
              </li>
            </ul>
          </div>
        }
        @default {
          <div animate.enter="fade-in" animate.leave="fade-out">
            <ng-container *ngTemplateOutlet="skeleton" />
          </div>
        }
      }
      <ng-template #viewer />
    </div>
  </div>
</app-card-shell>
